import BlankQuestionViewer from './BlankQuestionViewer';
import BooleanQuestionViewer from './BooleanQuestionViewer';
import CheckboxQuestionViewer from './CheckboxQuestionViewer';
import ChoiceQuestionViewer from './ChoiceQuestionViewer';
import MatchQuestionViewer from './MatchQuestionViewer';
import OrderQuestionViewer from './OrderQuestionViewer';
import PollQuestionViewer from './PollQuestionViewer';
import QuestionFactory from './QuestionFactory';
export default {
    Factory: QuestionFactory,
    Blank: BlankQuestionViewer,
    Boolean: BooleanQuestionViewer,
    Checkbox: CheckboxQuestionViewer,
    Choice: ChoiceQuestionViewer,
    Match: MatchQuestionViewer,
    Order: OrderQuestionViewer,
    Poll: PollQuestionViewer
};
//# sourceMappingURL=index.js.map